import React from "react";
import { FPFooter } from "..";
import { FaArrowLeft, FaEye, FaEyeSlash } from "react-icons/fa6";
import { logo } from "../../assets/images";
import { useMutation } from "@apollo/client";
import { RESET_PASSWORD } from "../../apollo/operations";
import { showToast } from "../../utils/showToast";
import { Link, useNavigate } from "react-router-dom";

type PasswordResetProps = {
  setOpenOtp: React.Dispatch<React.SetStateAction<boolean>>;
};
const PasswordReset: React.FC<PasswordResetProps> = ({ setOpenOtp }) => {
  const [openEye, setOpenEye] = React.useState(false);
  const [openSecEye, setOpenSecEye] = React.useState(false);
  const [password, setPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");
  const storedEmails = localStorage.getItem("userEmails");
  const token = localStorage.getItem("token");

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const passwordInput = e.target.value.trim();
    setPassword(passwordInput);
  };

  const navigate = useNavigate();

  const handleConfirmPasswordChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const confirmPasswordInput = e.target.value.trim();

    setConfirmPassword(confirmPasswordInput);
    // if (confirmPasswordInput !== password) {
    //   setErrorMessage("Passwords do not match");
    // } else {
    //   setErrorMessage("");
    // }
  };

  const [updatePassword, { loading }] = useMutation(RESET_PASSWORD, {
    onCompleted: (data) => {
      // console.log(data.resetPassword.message, "dara");
      showToast(`${data.resetPassword.message}`, "success");
    },
    onError(error) {
      console.log(error.graphQLErrors);
    },
  });

  const handleResetPassword = () => {
    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match");
      return;
    } else {
      setErrorMessage("");
      updatePassword({
        variables: {
          credentials: {
            password: password,
            confirmPassword: confirmPassword,
            email: storedEmails,
            token: token,
          },
        },
      }).then((e) => {
        if (e.errors) {
          console.log(e.errors);
        }

        if (!loading) {
          navigate("/auth");
        }
      });
    }
  };
  return (
    <div className="w-full h-full lg:py-[112px] lg:px-[180px] mt-[60px] lg:mt-0 flex items-center justify-center lg:bg-inherit bg-white">
      <div className="w-[800px] h-[773px]">
        <div className="flex h-[140px] w-full lg:bg-[#DDFFEA] items-center justify-center">
          <img src={logo} alt="" className="w-[84.45px] h-[83.81px]" />
        </div>
        <div className="w-full h-[calc(773px-140px)] lg:py-8 bg-white lg:px-[53px]">
          <div className="flex w-full lg:px-[110px] mb-10 gap-5 justify-center">
            <div className="hidden lg:flex h-full pt-2">
              <FaArrowLeft onClick={() => setOpenOtp(false)} />
            </div>
            <div className="flex-1 px-5">
              <div className="flex w-full flex-col lg:text-center justify-center">
                <h4 className="font-semibold font-Poppins text-[28px]">
                  {"Reset your password"}
                </h4>
                <p className="font-Poppins text-base lg:mt-5 mt-3">
                {"Type in your password."}
                </p>
              </div>
              <div className="w-full mt-8 relative">
                <div className="w-full relative">
                  {!openEye ? (
                    <FaEyeSlash
                      size={24}
                      className="absolute right-2 top-5 cursor-pointer"
                      onClick={() => setOpenEye(!openEye)}
                    />
                  ) : (
                    <FaEye
                      size={24}
                      className="absolute right-2 top-5 cursor-pointer"
                      onClick={() => setOpenEye(!openEye)}
                    />
                  )}

                  <input
                    placeholder="Enter New Password"
                    value={password}
                    type={openEye ? "text" : "password"}
                    onChange={handlePasswordChange}
                    className="w-full h-[62px] flex items-center px-6 rounded-lg bg-[rgba(38,50,56,0.05)] placeholder:font-Poppins placeholder:text-[15px] placeholder:text-[33363F] outline-none text-[#33363F]"
                  />
                </div>

                <div className="w-full relative mt-5">
                  {!openSecEye ? (
                    <FaEyeSlash
                      size={24}
                      className="cursor-pointer absolute right-2 top-5"
                      onClick={() => setOpenSecEye(!openSecEye)}
                    />
                  ) : (
                    <FaEye
                      size={24}
                      className="cursor-pointer absolute right-2 top-5"
                      onClick={() => setOpenSecEye(!openSecEye)}
                    />
                  )}
                  <input
                    placeholder="Enter New Password"
                    value={confirmPassword}
                    type={openSecEye ? "text" : "password"}
                    onChange={handleConfirmPasswordChange}
                    className="w-full h-[62px] flex items-center px-6 rounded-lg bg-[rgba(38,50,56,0.05)] placeholder:font-Poppins placeholder:text-[15px] placeholder:text-[33363F] outline-none text-[#33363F]"
                  />
                </div>

                {errorMessage && (
                  <p
                    className="absolute top-[143px] left-1 font-Poppins text-xs"
                    style={{ color: "red" }}
                  >
                    {errorMessage}
                  </p>
                )}
                <button
                  type="submit"
                  onClick={handleResetPassword}
                  className="my-5 w-full flex items-center justify-center h-[62px] rounded-lg bg-midGreen text-white font-LexendDeca font-semibold text-base"
                >
                  Reset
                </button>
                <Link
                  to={`/auth`}
                  className="w-full flex items-center justify-center h-[62px] rounded-lg border border-solid border-midGreen font-semibold font-LexendDeca text-sm"
                >
                  Back to Login
                </Link>
              </div>
            </div>
          </div>
          <FPFooter />
        </div>
      </div>
    </div>
  );
};

export default PasswordReset;
